import Cookies from 'js-cookie'

const TokenKey = 'Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const PermissionKey = 'Role'

export function getRole() {
  return Cookies.get(PermissionKey)
}

export function setRole(role) {
  return Cookies.set(PermissionKey, role)
}

export function removeRole() {
  return Cookies.remove(PermissionKey)
}
